import { Checkbox } from '@chaysehartsuff/active-html';

export default class AloCheckbox extends Checkbox {
 
    constructor() {
        super();
        //this.addClass('');
    }
}